<script>

    import { toast } from 'bulma-toast'
    import { modalStore, pricesStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import PricesService from '../$services/prices.service'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Providers from '../$components/providers.svelte'
    import Select from '../$components/select.svelte'
    import Search from '../$components/input.search.svelte'
    import Button from '../$components/button.svelte'
    import Table from '../$components/table.svelte'

    let loading = false

    export let query = {
        all: true,
    }

    $: skeletonCols = query.all ? 10 : 8

    let tags = []

    // Tipo (usuario/públicos) y Etiqueta filtran el mismo campo type: elegir uno limpia el otro
    let type = ''
    let tag = ''

    getPrices()

    if(query.all)
        getTags()

    function changeType() {
        tag = ''
        query.type = type
        getPrices()
    }

    function changeTag() {
        type = ''
        query.type = tag
        getPrices()
    }

    async function getTags() {

        const resp = await PricesService.getTags()

        if(resp.success)
            tags = resp.data
    }

    // solo los precios de usuario expiran; los públicos y los de etiqueta siempre aplican
    function isExpired(price) {
        return price.type === 'user' && DateMethods.isBefore(price.expired)
    }

    async function getPrices() {

        loading = true
        const resp = await PricesService.getPrices(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pricesStore.set(resp.data)
    }

    function getValor(price) {

        if(price.pricing === 'price')
            return NumeralMethods.cash(price.value)

        if(price.pricing === 'percent')
            return `${ price.value }%`

        if(price.pricing === 'amount')
            return NumeralMethods.cash(price.value)

        return price.value
    }

</script>

<Table items={ $pricesStore.length } { loading } { skeletonCols }>
    <div slot="header" class="header-filters">
        {#if query.all}
            <div class="header-top">
                <Search on:enter={getPrices} bind:value={query.find} />
                {#if isPermission($adminStore, 'UsersView.Price.Create')}
                    <Button on:click={() => modalStore.set('price_create_modal')} icon="plus" text="Agregar" />
                {/if}
            </div>
            <div class="header-actions">
                <Select
                    on:change={changeType}
                    bind:value={type}
                    text="Tipo"
                    size="small"
                    options={[
                        {value: 'user', text: 'Usuario'},
                        {value: 'public', text: 'Publicos'},
                    ]}
                />
                <Select
                    on:change={changeTag}
                    bind:value={tag}
                    text="Etiqueta"
                    size="small"
                    options={tags.map(item => ({value: item, text: item}))}
                />
                <div class="providers-filter">
                    <Providers on:change={getPrices} bind:provider={ query.provider } bind:service={ query.service } hideLabels isVoid size="small" />
                </div>
            </div>
        {:else}
            <div class="header-top">
                <div class="providers-filter providers-filter_grow">
                    <Providers on:change={getPrices} bind:provider={ query.provider } bind:service={ query.service } hideLabels isVoid size="small" />
                </div>
                {#if isPermission($adminStore, 'UsersView.Price.Create')}
                    <Button on:click={() => modalStore.set('price_create_modal')} icon="plus" text="Agregar" />
                {/if}
            </div>
        {/if}
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            {#if query.all}
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-tag"></i></span>
                        <span>Tipo</span>
                    </span>
                </th>
            {/if}
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Proveedor</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-shipping-fast"></i></span>
                    <span>Servicio</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-weight"></i></span>
                    <span>Volumétrico</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-tags"></i></span>
                    <span>Pricing</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>Valor</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Expiración</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $pricesStore as price, index}
            <tr>
                <td>{ index + 1 }</td>
                <td class:color-danger={isExpired(price)}>
                    { isExpired(price)? 'Expiró' : 'Activo' }
                </td>
                {#if query.all}
                    <td>
                        <div class="td-stack">
                            <div>{ TranslateMethods.get(price.type) }</div>
                            {#if price.type === 'user'}
                                <small>{ price.user.email }</small>
                            {/if}
                        </div>
                    </td>
                {/if}
                <td>{ price.provider }</td>
                <td>{ price.service }</td>
                <td>{ price.volumetricMin }KG A { price.volumetricMax }KG</td>
                <td>{ TranslateMethods.get(price.pricing) }</td>
                <td>{ getValor(price) }</td>
                <td>{ price.expired? DateMethods.dateTimeLarge(price.expired) : '—' }</td>
                <td>
                    <Button on:click={() => modalStore.open('price', 'modal', price)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
